import { render, staticRenderFns } from "./ProcedimientosPagination.vue?vue&type=template&id=646f04e4&"
import script from "./ProcedimientosPagination.vue?vue&type=script&lang=js&"
export * from "./ProcedimientosPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports